import { z } from 'zod';
import { DELIVERY_CHANGE_REASON_MAX_LENGTH } from './delivery-change-reason-max-length.js';
const TOO_LONG_MESSAGE = `Keep the reason to ${DELIVERY_CHANGE_REASON_MAX_LENGTH} characters or fewer.`;
// History shows the reason, so a blank one is refused too (OTC-45).
function deliveryChangeReasonSchema(requiredMessage) {
    return z
        .string({ error: requiredMessage })
        .trim()
        .min(1, requiredMessage)
        .max(DELIVERY_CHANGE_REASON_MAX_LENGTH, TOO_LONG_MESSAGE);
}
export const rescheduleDeliveryReasonSchema = deliveryChangeReasonSchema('Enter a reason for rescheduling this delivery.');
export const failedDeliveryReasonSchema = deliveryChangeReasonSchema('Enter a reason for the failed delivery.');
//# sourceMappingURL=delivery-change-reason-schema.js.map